import React, { useState, useLayoutEffect, useContext, useEffect } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import {
  getProduct,
  getProductImage,
  getProductComment,
  getProductProperty,
  setProductComment,
  moshabeh,
  setFavorite,
  favoriteCheck,
  BasketHistory,
  BasketHistoryDeatils,
} from "../axios";
import { toast } from "react-toastify";
import ProductSection from "../components/product/productSections";
import { separate } from "../tools/helper";
import { CartContext } from "../components/shared/context/cart-context";
import { ExistDataContext } from "../components/shared/context/dataExist-context";
import PdfViewDemo from "../components/pdfViewDemo";
import ImageGallery from "react-image-gallery";
import VideoViewDemo from "../components/VideoViewDemo";
import { UserIcon } from "../assets/Icons";
import PDF from "../../src/assets/img/icon/pdf.png";
import { Document, Page, pdfjs } from "react-pdf";
import { getProducts } from "./../axios";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const ProductSingle = () => {
  const { id } = useParams();
  // const [id, setId] = useState(null);
  // const location = useLocation();
  const [recived, setRecived] = useState({});
  const [step, setStep] = useState(2);
  const [properties, setProperties] = useState([]);
  const [userName, setUserName] = useState("");
  const [description, setDescription] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [products, setProducts] = useState([]);
  const [downloadOkay, setDownloadOkay] = useState(false);
  const [comment, setComment] = useState([]);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  let ext = recived.filedemo?.split(".").pop();
  const styles = {
    page: {
      backgroundColor: "white",
    },
    viewer: {
      width: window.innerWidth, //the pdf viewer will take up all of the width and height
      height: window.innerHeight,
    },
  };

  useEffect(() => {
    setLoading(true);
    getProducts().then(({ data }) => {
      const currentProduct = data.find((product) => product.id == id);
      if (currentProduct) {
        // console.log("currentProduct: " + currentProduct);
        // setId(currentProduct.id);
        setRecived(currentProduct);
        setLoading(false);
      }
    });
  }, [id]);

  // useEffect(() => {
  //   let idLocation = location?.search.split("=")[1];
  //   if (idLocation) setId(idLocation);
  // }, [location]);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const nextPage = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  const prevPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  useLayoutEffect(() => {
    if (localStorage.getItem("login")) {
      BasketHistory(localStorage.getItem("phonenumber")).then(({ data }) => {
        data?.map((item) => {
          BasketHistoryDeatils(item.id).then(({ data }) => {
            data?.map((itemD) => {
              if (itemD.id == id) {
                setDownloadOkay(true);
              }
            });
          });
        });
      });
    }
  }, [id]);

  // console.log("id is ", id);

  useEffect(() => {
    if (id) {
      getProductComment(id).then(({ data }) => {
        setComment(data);
      });
      getProductProperty(id).then(({ data }) => {
        setProperties(data);
      });
      moshabeh(id).then(({ data }) => {
        if (data) {
          Object.entries(data).forEach(([key, value]) => {
            // Skip processing if the key is 'id'
            if (key === "id") return;

            if (value !== 0) {
              getProduct(value).then(({ data }) => {
                if (data.length > 0) {
                  setProducts((products) => [...products, data[0]]);
                }
              });
            }
          });
        }
      });
    }
  }, [id]);

  const submitComment = (e) => {
    e.preventDefault();
    setProductComment(id, phoneNumber, description, userName).then(() => {
      toast.success("کامنت شما با موفقیت ثبت شد");
      setDescription("");
      setPhoneNumber("");
      setUserName("");
    });
  };

  const addToFavorite = (e, id) => {
    if (localStorage.getItem("login")) {
      e.preventDefault();
      favoriteCheck(id, "09192928194").then(({ data }) => {
        // console.log(data);
      });
      setFavorite(id, "09192928194").then(({ data }) => {
        toast.success("به لیست علاقه مندی ها اضافه شد");
      });
    } else {
      toast.error("لطفا ابتدا از بخش منو بالا وارد حساب کاربری خود شوید");
    }
  };

  const [cartItems, setCartItems] = useContext(CartContext);

  const [existProduct] = useContext(ExistDataContext);

  const existsInArray = (array, id) => {
    return array.some((item) => item.productID === id);
  };
  const existsInArraySecond = (array, id) => {
    return array.some((item) => item.id === id);
  };

  const addToSabadKharidHandler = (e, value) => {
    e.preventDefault();
    const existData = existsInArray(existProduct, value.id);

    if (existData === false || value.categoryID === 1) {
      if (localStorage.getItem("login")) {
        let existProductAdd = existsInArraySecond(cartItems, value.id);
        let array = [...cartItems];
        if (existProductAdd == true && value.categoryID == 1) {
          try {
            array.push(value);
            setCartItems(array);
            toast.success("به سبد خرید اضافه شد");
          } catch (error) {
            console.log(error.message);
          }
        } else if (existProductAdd == false && value.categoryID != 1) {
          try {
            array.push(value);
            setCartItems(array);
            toast.success("به سبد خرید اضافه شد");
          } catch (error) {
            console.log(error.message);
          }
        } else if (existProductAdd == true && value.categoryID != 1) {
          toast.error(
            "کاربر گرامی محصول مورد نظر را قبلا به سبد خرید اضافه کرده اید"
          );
        } else {
          try {
            array.push(value);
            setCartItems(array);
            toast.success("به سبد خرید اضافه شد");
          } catch (error) {
            console.log(error.message);
          }
        }
      } else {
        toast.error("لطفا ابتدا از بخش منو بالا وارد حساب کاربری خود شوید");
      }
    } else {
      return toast.error("این محصول قبلا خریداری شده است.");
    }
  };

  const [imageGallery, setImageGallery] = useState([]);
  const [galleryLoading, setGalleryLoading] = useState(null);
  useEffect(() => {
    const getGalleryImages = async () => {
      setGalleryLoading(true); // Start loading
      let array = [];
      if (recived) {
        array.push({ original: recived?.img, thumbnail: recived?.img });
        try {
          const { data } = await getProductImage(recived?.id);
          // console.log("data", data);

          if (data.length > 0) {
            data?.forEach((item) => {
              array.push({ original: item.img, thumbnail: item.img });
            });
          }
        } catch (error) {
          console.error(error);
        }
      }
      setImageGallery(array);
      setGalleryLoading(false); // End loading
    };

    getGalleryImages();
  }, [recived, getProductImage]);
  

  // ---------------------------------------- React Scroll

  const handleDemo = (e) => {
    e.preventDefault();
    const targetElement = document.getElementById("targetItem");
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  // const images = imageGallery?.push({ original: recived.img, thumbnail: recived.img });

  // --------------------------------------------- for pdf

  const [result, setResult] = useState();
  useEffect(() => {
    getProduct(id).then(({ data }) => {
      setResult(data[0]);
    });
  }, [id]);

  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  // console.log("images", imageGallery);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", margin: 90 }}>
        <div className="loader-6 centerLoader">
          <span></span>
        </div>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="breadcrumbs_area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb_content">
                <ul>
                  <li>
                    <Link to="/">خانه</Link>
                  </li>
                  <li>جزئیات محصول</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="product_details mt-60 mb-60">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="product-details-tab">
                <div id="img-1" className="zoomWrapper single-zoom">
                  {/* <img id="zoom1" src={recived.img} data-zoom-image={recived.img} alt="big-1" /> */}
                  {galleryLoading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        margin: 90,
                      }}
                    >
                      <div className="loader-6 centerLoader">
                        <span></span>
                      </div>
                    </div>
                  ) : (
                    <ImageGallery
                      showPlayButton={false}
                      showBullets={false}
                      showNav={false}
                      items={imageGallery}
                      isRTL={true}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="product_d_right">
                <form action="#">
                  <h1 className="user-select-none">{recived?.title}</h1>
                  <div className="price_box">
                    {recived?.price === recived?.priceTakhfif ? (
                      recived?.price == 0 ? (
                        <h4 className="price">رایگان</h4>
                      ) : (
                        <span className="current_price">
                          {separate(recived?.price)} تومان
                        </span>
                      )
                    ) : (
                      <React.Fragment>
                        <span className="old_price">
                          <del>{separate(recived?.price)} تومان</del>
                        </span>
                        <span className="current_price">
                          {separate(recived?.priceTakhfif)} تومان
                        </span>
                      </React.Fragment>
                    )}
                  </div>
                  <div className="product_desc">
                    {recived?.description?.includes("<") ? (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: recived.description,
                        }}
                      ></p>
                    ) : (
                      <p style={{ whiteSpace: "pre-line" }}>
                        {recived?.description}
                      </p>
                    )}
                    {/* <button
                      className="btn btn-sm bg-primary text-white shadow"
                      onClick={handleDemo}
                    >
                      مشاهده دمو
                    </button> */}
                  </div>
                  {!downloadOkay && recived?.price !== "0" && (
                    <div className="product_variant quantity">
                      {recived.inventory > 0 ? (
                        <button
                          style={{ color: "white" }}
                          className="button mr-auto"
                          onClick={(e) => addToSabadKharidHandler(e, recived)}
                        >
                          افزودن به سبد خرید
                        </button>
                      ) : (
                        <button
                          className="button mr-auto bg-light text-danger"
                          disabled
                        >
                          عدم موجودی
                        </button>
                      )}
                    </div>
                  )}

                  <div className="product_d_action">
                    <ul>
                      <li>
                        <Link
                          onClick={(e) => addToFavorite(e, recived?.id)}
                          title="افزودن به علاقه‌مندی‌ها"
                        >
                          <i className="fa fa-heart" aria-hidden="true"></i>
                          <span> افزودن به علاقه‌مندی‌ها</span>
                        </Link>
                      </li>
                    </ul>
                    {/* <Link className="btn btn-primary btn-sm mt-3" to={`/video-view/${recived.id}`}>
                      مشاهده دمو
                    </Link> */}
                  </div>
                  <div className="product_meta">
                    <span>
                      دسته:{" "}
                      <Link to={`/shop?id=${recived?.categoryID}`}>
                        {recived?.categoryTitle}
                      </Link>
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />
      <div className="product_d_info mb-60">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="product_d_inner">
                <div className="product_info_button">
                  {/* <ul className="nav" role="tablist">
                    <li onClick={() => setStep(1)}>
                      <a
                        className="active"
                        data-toggle="tab"
                        role="tab"
                        aria-controls="info"
                        aria-selected="false"
                      >
                        توضیحات محصول
                      </a>
                    </li>
                    {properties.length > 0 ? (
                      <li onClick={() => setStep(2)}>
                        <button className="btn btn-sm" data-toggle="tab" role="tab" aria-controls="sheet" aria-selected="false">
                          جزئیات
                        </button>
                      </li>
                    ) : (
                      ""
                    )}
                    <li onClick={() => setStep(3)}>
                      <a data-toggle="tab" role="tab" aria-controls="reviews" aria-selected="false">
                        نظرات
                      </a>
                    </li>
                    <li onClick={() => setStep(4)}>
                      <a data-toggle="tab" role="tab" aria-controls="reviews" aria-selected="false">
                        پیش نمایش
                      </a>
                    </li>
                  </ul> */}
                  <ul className="nav nav-tabs">
                    {/* <li className="nav-item" onClick={() => setStep(1)}>
                      <button
                        className={`${
                          step === 1 ? "active" : "disabled"
                        } nav-link`}
                        style={{ whiteSpace: "pre-line" }}
                      >
                        توضیحات محصول
                      </button>
                    </li> */}
                    {properties?.length > 0 && (
                      <li className="nav-item" onClick={() => setStep(2)}>
                        <button
                          className={`${
                            step === 2 ? "active productSingle-nav" : "disabled"
                          } nav-link`}
                        >
                          جزئیات
                        </button>
                      </li>
                    )}
                    <li
                      id="targetItem"
                      className="nav-item"
                      onClick={() => setStep(4)}
                    >
                      <button
                        className={`${
                          step === 4 ? "active productSingle-nav" : "disabled"
                        } nav-link`}
                      >
                        پیش نمایش
                      </button>
                    </li>
                    <li className="nav-item" onClick={() => setStep(3)}>
                      <button
                        className={`${
                          step === 3 ? "active productSingle-nav" : "disabled"
                        } nav-link`}
                      >
                        نظرات
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="tab-content">
                  {step === 1 ? (
                    <div
                      className="tab-pane fade show active"
                      id="info"
                      role="tabpanel"
                    >
                      <div className="product_info_content">
                        {recived?.description?.includes("<") ? (
                          <p
                            dangerouslySetInnerHTML={{
                              __html: recived.description,
                            }}
                          ></p>
                        ) : (
                          <p style={{ whiteSpace: "pre-line" }}>
                            {recived?.description}
                          </p>
                        )}
                      </div>
                    </div>
                  ) : step === 2 ? (
                    <div
                      className="tab-pane fade show active"
                      id="sheet"
                      role="tabpanel"
                    >
                      <div className="product_d_table">
                        <form action="#">
                          <table className="table table-borderless table-striped">
                            <tbody>
                              {properties?.map((item, index) => (
                                <tr key={index}>
                                  <td className="first_child">{item?.title}</td>
                                  <td>{item?.property}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </form>
                      </div>
                    </div>
                  ) : step === 3 ? (
                    <div
                      className="tab-pane fade show active"
                      id="reviews"
                      role="tabpanel"
                    >
                      <div className="reviews_wrapper">
                        {comment?.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className="d-flex align-items-center my-2"
                            >
                              <span
                                className="border rounded-circle shadow-sm mr-2 d-flex align-items-center justify-content-center"
                                style={{ width: "40px", height: "40px" }}
                              >
                                <UserIcon />
                              </span>
                              <p style={{ fontSize: "13px", color: "#0f0f0f" }}>
                                {item?.description}
                              </p>
                            </div>
                          );
                        })}

                        <div className="comment_title">
                          <h2>یک نقد و بررسی بنویسید </h2>
                          <p>شماره موبایل شما منتشر نخواهد شد. </p>
                        </div>

                        <div className="product_review_form">
                          <form action="#" method="post">
                            <div className="row">
                              <div className="col-12">
                                <label for="review_comment">
                                  نقد و بررسی شما{" "}
                                </label>
                                <textarea
                                  value={description}
                                  onChange={(e) =>
                                    setDescription(e?.target?.value)
                                  }
                                  name="comment"
                                  id="review_comment"
                                ></textarea>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                <label for="author">نام</label>
                                <input
                                  value={userName}
                                  onChange={(e) =>
                                    setUserName(e?.target?.value)
                                  }
                                  id="author"
                                  type="text"
                                ></input>
                              </div>
                              <div className="col-lg-6 col-md-6">
                                <label for="email">شماره همراه </label>
                                <input
                                  value={phoneNumber}
                                  onChange={(e) =>
                                    setPhoneNumber(e?.target?.value)
                                  }
                                  id="email"
                                  type="text"
                                  dir="ltr"
                                ></input>
                              </div>
                            </div>
                            <button onClick={(e) => submitComment(e)}>
                              ثبت
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="tab-pane fade show active"
                      id="sheet"
                      role="tabpanel"
                    >
                      {ext === "pdf" ? (
                        <PdfViewDemo/>
                        // <div className="bar ">
                        //   <div
                        //     className="wrap text-center"
                        //     onContextMenu={(e) => e.preventDefault()}
                        //   >
                        //     <div
                        //       className="controls"
                        //       onContextMenu={(e) => e.preventDefault()}
                        //     >
                        //       <button
                        //         className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
                        //         style={{ height: "40px" }}
                        //         onClick={prevPage}
                        //         disabled={pageNumber === 1}
                        //       >
                        //         قبلی
                        //       </button>
                        //       <button
                        //         className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
                        //         style={{ height: "40px" }}
                        //         onClick={nextPage}
                        //         disabled={pageNumber === numPages}
                        //       >
                        //         بعدی
                        //       </button>
                        //     </div>

                        //     <Document
                        //       file={result && result?.filedemo}
                        //       onLoadSuccess={onDocumentLoadSuccess}
                        //       onContextMenu={(e) => e.preventDefault()}
                        //       className="pdf-contailner"
                        //     >
                        //       <Page
                        //         style={styles.page}
                        //         pageNumber={pageNumber}
                        //         onContextMenu={(e) => e.preventDefault()}
                        //       />
                        //     </Document>
                        //   </div>
                        // </div>
                      ) : ext === "mp4" || ext === "mp3" ? (
                        <VideoViewDemo />
                      ) : ext === "jpg" || ext === "png" ? (
                        <img
                          src={result?.filedemo}
                          alt="Preview"
                          style={{ maxWidth: "100%", height: "auto" }}
                        />
                      ) : (
                        <p>Unsupported file type</p>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ProductSection
        title="محصولات مشابه"
        listProducts={products}
        recived={recived}
      />
    </React.Fragment>
  );
};

export default ProductSingle;
